// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-input-container {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    border: 2px solid var(--border-color);
    border-radius: 5px;
    background-color: var(--cinza-fundo-input-padrao);
    padding: 0 1rem;
}

.password-input-container:hover {
    outline: 2px solid var(--azul-dixi);
}

.password-input-field {
    flex: 1 1;
    padding: 0.8rem 0.8rem 0.8rem 2.2rem;
    border: none;
    background-color: transparent;
    color: var(--text-color);
    font-size: 1rem;
    outline: none;
    font-weight: 500;
    opacity: .9;
}

.password-input-field::placeholder {
    font-size: .9rem;
    font-weight: bold;
    opacity: .7;
}

.icon-lock {
    position: absolute;
    left: 0.8rem;
    color: var(--cinza-placeholder);
    font-size: 1.5rem;
    font-weight: bold;
}

.icon-eye-container {
    position: absolute;
    right: 0.8rem;
    top: 10px;
    cursor: pointer;
}

.icon-eye {
    color: var(--cinza-placeholder);
    font-size: 1.5rem;
}

.icon-eye:hover, .mostra-senha {
    color: var(--azul-dixi);
}
  
.erro-invalido {
    outline: 2px solid var(--error-color);
    border-radius: 5px;
}

.password-input-container.erro-invalido:hover {
    outline: 2px solid var(--error-color);
}`, "",{"version":3,"sources":["webpack://./src/components/InputSenha/InputSenha.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,kBAAkB;IAClB,iDAAiD;IACjD,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,SAAO;IACP,oCAAoC;IACpC,YAAY;IACZ,6BAA6B;IAC7B,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;AACzC","sourcesContent":[".password-input-container {\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    border: 2px solid var(--border-color);\n    border-radius: 5px;\n    background-color: var(--cinza-fundo-input-padrao);\n    padding: 0 1rem;\n}\n\n.password-input-container:hover {\n    outline: 2px solid var(--azul-dixi);\n}\n\n.password-input-field {\n    flex: 1;\n    padding: 0.8rem 0.8rem 0.8rem 2.2rem;\n    border: none;\n    background-color: transparent;\n    color: var(--text-color);\n    font-size: 1rem;\n    outline: none;\n    font-weight: 500;\n    opacity: .9;\n}\n\n.password-input-field::placeholder {\n    font-size: .9rem;\n    font-weight: bold;\n    opacity: .7;\n}\n\n.icon-lock {\n    position: absolute;\n    left: 0.8rem;\n    color: var(--cinza-placeholder);\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.icon-eye-container {\n    position: absolute;\n    right: 0.8rem;\n    top: 10px;\n    cursor: pointer;\n}\n\n.icon-eye {\n    color: var(--cinza-placeholder);\n    font-size: 1.5rem;\n}\n\n.icon-eye:hover, .mostra-senha {\n    color: var(--azul-dixi);\n}\n  \n.erro-invalido {\n    outline: 2px solid var(--error-color);\n    border-radius: 5px;\n}\n\n.password-input-container.erro-invalido:hover {\n    outline: 2px solid var(--error-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
